export enum CommunityGiftsActionTypes {
  FETCHING = 'communityGift/FETCHING',
  RECEIVED = 'communityGift/RECEIVED ',
  ERROR = 'communityGift/FETCH-ERROR',
  CLAIMING = 'communityGift/CLAIMING',
  CLAIMED = 'communityGift/CLAIMED ',
  ERROR_CLAIMING = 'communityGift/ERROR_CLAIMING',
}
